// extracted by mini-css-extract-plugin
export var caption = "img-cols-module--caption--3cf2a";
export var caption_acenter = "img-cols-module--caption_acenter--7c9c5";
export var caption_aright = "img-cols-module--caption_aright--27143";
export var copy_body = "img-cols-module--copy_body--622e1";
export var copy_cta = "img-cols-module--copy_cta--669cc";
export var curr = "img-cols-module--curr--1d030";
export var image = "img-cols-module--image--ce3f0";
export var img = "img-cols-module--img--34ef2";
export var img_cols = "img-cols-module--img_cols--ae1f5";
export var ind_dot = "img-cols-module--ind_dot--e3ed0";
export var indicate = "img-cols-module--indicate--101bd";
export var item = "img-cols-module--item--80365";
export var nd_solo = "img-cols-module--nd_solo--27563";
export var nd_tre = "img-cols-module--nd_tre--2afef";
export var no_gap = "img-cols-module--no_gap--1c9a3";
export var no_margin = "img-cols-module--no_margin--237a5";
export var same_size = "img-cols-module--same_size--4002e";
export var smaller = "img-cols-module--smaller--10657";
export var subtitle = "img-cols-module--subtitle--7785f";
export var swipe_cols = "img-cols-module--swipe_cols--73050";
export var swipe_colwr = "img-cols-module--swipe_colwr--964e7";
export var title = "img-cols-module--title--4a137";
export var title_wr = "img-cols-module--title_wr--27892";